import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "@/lib/api";

// Authenticated axios for admin calls (sends cookies + bearer header fallback)
export const adminApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Add Authorization header from localStorage fallback if a bearer was saved
adminApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("pyp_admin_token");
  if (t) config.headers["Authorization"] = `Bearer ${t}`;
  return config;
});

export function useAdminAuth() {
  // null = checking, false = unauthenticated, object = user
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);

  const checkAuth = useCallback(async () => {
    // If returning from OAuth callback, skip — AuthCallback handles it
    if (window.location.hash?.includes("session_id=")) {
      setChecked(true);
      return;
    }
    try {
      const r = await adminApi.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(false);
    } finally {
      setChecked(true);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    try {
      await adminApi.post("/auth/logout");
    } catch {
      /* ignore — we're logging out anyway */
    }
    localStorage.removeItem("pyp_admin_token");
    setUser(false);
  }, []);

  return { user, checked, logout, refresh: checkAuth };
}

export function loginWithGoogle() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/admin";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}
